import { Space, Card, Divider, Col, Tabs, Statistic, Tooltip } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import {useEffect, useState} from 'react'
import ProductListBasicTable from './ProductListBasicTable'
import ProductInventoryTransition from '../components/ProductInventoryTransition'
import ProductBasicForm from './ProductBasicForm'
import useGetStockList from '../hooks/useGetStockList'
import useBatchUpdateStock from '../hooks/useBatchUpdateStock'
import useStockStoreTypeContext from '../hooks/useStockStoreTypeContext'
import { StockStoreTypeEnum, StockStoreTypeMap } from '../config'
import ProductStockItemBtns from './ProductStockItemBtns'
import { StoreCode } from '../context'
import service from '../../../@services'
import '../../../style/statistic.less'

const tabs = StockStoreTypeEnum.map(item => ({
  key: item,
  tab: StockStoreTypeMap[item]
}))
const defaultStatistic = {
  costTotal: 0,
  remainStock: 0
}
export default function StockPanel({ setActiveTab }) {
  const [skuId, setSkuId] = useState(null)
  const { isRealStock, stockStoreType, stockTypeText } =
    useStockStoreTypeContext()
  const [storeCode, setStoreCode] = useState(null)
  const { getList, pageData, loading } = useGetStockList()

  const [statistic, setStatis] = useState(defaultStatistic)

  const getStatics = async params => {
    if (isRealStock) {
      const res = await service.inventory.getStatics(params)
      if (res) {
        setStatis(res)
      } else {
        setStatis(defaultStatistic)
      }
      return res
    } else {
      Promise.resolve()
    }
  }
  const getMainData = params => {
    params.formData &&
      params.formData.storeCode &&
      setStoreCode(params.formData.storeCode)
    return Promise.all([getStatics(params.formData), getList(params)])
  }

  const { exportData, setSelectedItems } = useBatchUpdateStock(getList)
  const freshMainData = () => {
    getList()
    getStatics()
  }
  const tableChange =(pagination, filters, sorter) =>{
    const { current, pageSize } = pagination
    const sortMap = {
      descend: 'DESC',
      ascend: 'ASC',
    }
    const sortFieldMap = {
      costPrice:'COST_PRICE', stock:'STOCK'
    }
    const  params = {
      pageIndex: current,
      pageSize: pageSize,
      formData: {
        sortField: sorter.column?sortFieldMap[sorter.column.dataIndex]:undefined,
        sortType: sortMap[sorter.order],
        storeCode: storeCode
      }
    }
    getList(params)
  }
  let staticNode = '',
    otherColumns = [
      {
        title: '操作',
        dataIndex: 'operate',
        render: (text, record) => (
          <ProductStockItemBtns
            storeCode={storeCode}
            setSkuId={setSkuId}
            record={record}
            freshList={freshMainData}
          />
        )
      }
    ]
  if (isRealStock) {
    staticNode = (
      <Space className='total-box' split={<Divider type='vertical' />}>
        <Statistic title='成本总额（元）' value={statistic.costTotal} />
        <Statistic title='剩余总库存' value={statistic.remainStock} />
      </Space>
    )
    otherColumns = [
      {
        title: (
          <Tooltip title='移动平均价'>
            <div>
              <span style={{ marginRight: '6px' }}>成本价</span>
              <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
            </div>
          </Tooltip>
        ),
        dataIndex: 'costPrice',
        render: (text) => (
            <div style={{ fontSize: 12 }}>
              {text || '-'}
            </div>
        ),
        sorter: true,
        showSorterTooltip: false,
      },
      {
        title: (
          <Tooltip title='成本总额=剩余库存*成本价'>
            <div>
              <span style={{ marginRight: '6px' }}>成本总额</span>
              <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
            </div>
          </Tooltip>
        ),
        showSorterTooltip: false,
        dataIndex: 'costTotal'
      },
      ...otherColumns
    ]
  }

  const formExportData = formData =>
    exportData({
      ...formData,
      stockStoreType,
      pageIndex: pageData.pageIndex,
      pageSize: pageData.pageSize
    })
  return (
    <StoreCode.Provider value={{ storeCode, stockStoreType }}>
      <ProductBasicForm
        loading={loading}
        seachData={getMainData}
        exportData={formExportData}
      />
      <Tabs activeKey={stockStoreType} onChange={setActiveTab}>
        {tabs.map(item => (
          <Tabs.TabPane tab={item.tab} key={item.key}></Tabs.TabPane>
        ))}
      </Tabs>
      <Card>
        {staticNode}
        <div style={{ marginTop: '10px' }}></div>
        <ProductListBasicTable
          onTableChange={tableChange}
          loading={loading}
          otherColumns={otherColumns}
          pageData={pageData}
        />
      </Card>
      {skuId && (
        <ProductInventoryTransition
          setSkuId={setSkuId}
          storeCode={storeCode}
          stockStoreType={stockStoreType}
          skuId={skuId}
          title={'库存流水'}
          isOnline={!isRealStock}
        />
      )}
    </StoreCode.Provider>
  )
}
